import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { KpiService } from './kpi.service';

@Injectable({ providedIn: 'root' })
export class KpiCelulaAccessService {
  private readonly GRANTED_KEY = 'kpiCelulaGrantedPerms';
  private readonly PERMS = ['MANAGE_KPI_ASSIGNMENT', 'MANAGE_KPI_APPROVAL'];

  constructor(private kpiService: KpiService) {}

  /** Devuelve true si los permisos efectivos cambiaron. */
  refresh(): Observable<boolean> {
    const personId = this.currentPersonId();
    if (!personId) { return of(false); }
    return this.kpiService.getColaboradoresAsignadosComoAprobador(personId).pipe(
      map(members => this.apply((members ?? []).length > 0)),
      catchError(() => of(false))
    );
  }

  private apply(isLeader: boolean): boolean {
    let perms: { authority: string }[] = [];
    let granted: string[] = [];
    try { perms = JSON.parse(localStorage.getItem('permisions') || '[]'); } catch {}
    try { granted = JSON.parse(localStorage.getItem(this.GRANTED_KEY) || '[]'); } catch {}
    const has = (a: string) => perms.some(p => p.authority === a);
    let changed = false;
    if (isLeader) {
      this.PERMS.forEach(a => {
        if (!has(a)) { perms.push({ authority: a }); granted.push(a); changed = true; }
      });
    } else if (granted.length) {
      perms = perms.filter(p => !granted.includes(p.authority));
      granted = []; changed = true;
    }
    try {
      localStorage.setItem('permisions', JSON.stringify(perms));
      localStorage.setItem(this.GRANTED_KEY, JSON.stringify(granted));
    } catch {}
    return changed;
  }

  private currentPersonId(): string {
    try { return JSON.parse(localStorage.getItem('currentPerson') || '{}')?.id || ''; } catch { return ''; }
  }
}
